import {
  Title,
  Text,
  SimpleGrid,
  Card,
  Group,
  Badge,
  Stack,
  Anchor,
} from "@mantine/core";
import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { modulesApi } from "../api/modules.api";
import { getModuleIcon } from "../modules/registry";
import { useAuth } from "../auth/AuthContext";

export default function DashboardPage() {
  const { user } = useAuth();
  const { data: modules = [], isLoading } = useQuery({
    queryKey: ["modules"],
    queryFn: modulesApi.list,
  });

  return (
    <Stack gap="lg">
      <div>
        <Title order={2}>Welcome, {user?.fullName?.split(" ")[0]}</Title>
        <Text c="dimmed">
          Pick a module to get started. Modules without access do not appear
          here — contact an administrator to request them.
        </Text>
      </div>

      {isLoading ? (
        <Text c="dimmed">Loading modules…</Text>
      ) : modules.length === 0 ? (
        <Card>
          <Text c="dimmed">You have no modules assigned yet.</Text>
        </Card>
      ) : (
        <SimpleGrid cols={{ base: 1, sm: 2, md: 3 }}>
          {modules.map((m) => {
            const Icon = getModuleIcon(m.icon);
            const actions = Object.entries(m.actions || {})
              .filter(([, v]) => v)
              .map(([k]) => k);
            return (
              <Card key={m.key} withBorder padding="lg">
                <Group justify="space-between" mb="xs">
                  <Group gap="xs">
                    <Icon size={22} />
                    <Text fw={600}>{m.name}</Text>
                  </Group>
                </Group>
                <Text size="sm" c="dimmed" mb="md">
                  {m.description}
                </Text>
                <Group justify="space-between">
                  <Group gap={4}>
                    {actions.map((a) => (
                      <Badge key={a} variant="light" size="sm">
                        {a}
                      </Badge>
                    ))}
                  </Group>
                  <Anchor component={Link} to={m.path} size="sm">
                    Open →
                  </Anchor>
                </Group>
              </Card>
            );
          })}
        </SimpleGrid>
      )}
    </Stack>
  );
}
